// Function to get the backend URL based on the frontend domain
const API_BASE_URL = () => {
    const hostname = window.location.hostname;
  
    // Mapping frontend domains to backend URLs
    switch (hostname) {
      case 'prestadores.integrations.medipet.pt':
      case 'prestadores.integrations.habit.io':
      case 'localhost':
      case '127.0.0.1':
        return 'https://api.platform.integrations.habit.io';
      case 'prestadores.qa.medipet.pt':
      case 'prestadores.qa.habit.io':
        return 'https://api.platform.qa.habit.io';
      case 'prestadores.medipet.pt':
      case 'prestadores.habit.io':
        return 'https://api.platform.habit.io';
      default:
        return 'https://api.platform.habit.io'; // Default URL if none match
    }
  };

export const Providers = () => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const provider_id = userData['provider_id'];
    const role = userData['roles'][0];
    if(role === "PROVIDEROPERATOR")
      return `providers/parent`;
    else 
      return `providers/${provider_id}`;
}
 export const API_REGISTER = () => {
    const hostname = window.location.hostname;
  
    // Mapping frontend domains to backend URLs
    switch (hostname) {
      case 'prestadores.integrations.medipet.pt':
      case 'prestadores.integrations.habit.io':
      case 'localhost':
      case '127.0.0.1':
        return 'https://registo.integrations.medipet.pt';
      case 'prestadores.qa.medipet.pt':
      case 'prestadores.qa.habit.io':
        return 'https://registo.qa.medipet.pt';
      case 'prestadores.medipet.pt':
      case 'prestadores.habit.io':
        return 'https://registo.medipet.pt';
      default:
        return 'https://registo.medipet.pt'; // Default URL if none match
    }
  };

export default API_BASE_URL;
